export const shareItem = async ({ title, text }) => {
  const base = typeof window !== "undefined" ? window.location.origin : "https://satcom.id";
  const url = `${base}/#produk`;
  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (e) {
      /* dibatalkan / tidak didukung → fallback WhatsApp */
    }
  }
  const full = `${text}\n\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(full)}`, "_blank", "noopener");
};
